// Pagination.tsx
import { ChevronLeft, ChevronRight } from "lucide-react";
export function Pagination({
  page, numPages, onChange,
}: { page: number; numPages: number; onChange: (p: number) => void }) {
  if (numPages <= 1) return null;
  return (
    <div className="flex items-center justify-between px-1 py-3">
      <div className="text-sm text-surface-500">Page {page} of {numPages}</div>
      <div className="flex gap-2">
        <button
          disabled={page <= 1} onClick={() => onChange(page - 1)}
          className="h-9 w-9 flex items-center justify-center border border-surface-300 rounded-md disabled:opacity-40 hover:bg-surface-50"
        ><ChevronLeft className="h-4 w-4" /></button>
        <button
          disabled={page >= numPages} onClick={() => onChange(page + 1)}
          className="h-9 w-9 flex items-center justify-center border border-surface-300 rounded-md disabled:opacity-40 hover:bg-surface-50"
        ><ChevronRight className="h-4 w-4" /></button>
      </div>
    </div>
  );
}